module.exports = __webpack_public_path__ + "media/images/intro-logo-white-8cf2979a.png";